// src/theme/themes.js
import yofukashiTheme from "./yofukashi/theme";
import jashindpTheme from "./jashindp/theme";
import potionTheme from "./potion/theme";
import { chiTheme } from "./chi/theme";
import { ireneTheme } from "./irene/theme";
import higurashiTheme from "./higurashi/theme";

export const THEMES = {
  yofukashi: yofukashiTheme,
  jashindp: jashindpTheme,
  chi: chiTheme,
  irene: ireneTheme,
  higurashi: higurashiTheme,
  potion: potionTheme,
};
